import { render, staticRenderFns } from "./WizardItem.vue?vue&type=template&id=565512a2&"
import script from "./WizardItem.vue?vue&type=script&lang=js&"
export * from "./WizardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports